import { useState } from 'react';
import classNames from 'classnames';
import { Col, Row } from 'react-bootstrap';
import { AccordionSection } from '@medifind/containers';
import { AccordionSectionTab } from '@medifind/containers';
import { AccordionSectionTabs } from '@medifind/containers';
import { Skeleton } from '@medifind/shared-basic-components';
import styles from './ClinicalTrialShared.module.scss';

const EligibilityPane = ({ displayedData = [] }) => {
  const bulletify = () => {
    const bullets = ['•', '⁃', '‣', '∙'];
    const offsets = displayedData
      .filter(({ isHeader }) => !isHeader)
      .map(({ offset }) => offset)
      .sort((a, b) => a - b);
    const distictOffsets = [...new Set(offsets)];
    const offsetKey = distictOffsets.reduce((acc, offset, i) => {
      acc[offset] = bullets[i % bullets.length];
      return acc;
    }, {});
    return displayedData
      .filter(({ isHeader }) => !isHeader)
      .map(({ offset, line }) => ({
        offset,
        line: `${offsetKey[offset]} ${line}`,
      }));
  };

  return (
    <div className={styles['eligibility-pane']}>
      {displayedData &&
        bulletify().map(({ offset, line }, index) => {
          const margin = offset < 5 ? 0 : offset - 5;
          return (
            <p key={`${index}-${offset}`} style={{ marginLeft: `${margin * 0.25}rem` }}>
              {line}
            </p>
          );
        })}
    </div>
  );
};

const ClinicalTrialEligibility = ({ eligibility, isLoading }) => {
  const [selectedTab, setSelectedTab] = useState('inclusionParsed');
  return (
    <AccordionSection
      classes={{
        container: styles['accordian-container'],
        header: styles['accordian-header'],
        title: styles['accordian-title'],
        body: styles['accordian-body'],
      }}
      expandable
      title="Eligibility"
      isLoading={isLoading}
    >
      {eligibility ? (
        eligibility.map((eligibility, i) => {
          return (
            <div key={`elig-${i}`} style={{ marginBottom: 16 }}>
              <span className={classNames(styles['section-body-text'], styles['bold'])}>Participation Requirements</span>
              {eligibility.gender && (
                <Row>
                  <Col>
                    <span className={classNames(styles['section-body-text'], styles['bold'])}>Sex: </span>
                    <span>{eligibility.gender}</span>
                  </Col>
                </Row>
              )}
              {eligibility.minimumAge && (
                <Row>
                  <Col>
                    <span className={classNames(styles['section-body-text'], styles['bold'])}>Minimum Age: </span>
                    <span>{eligibility.minimumAge}</span>
                  </Col>
                </Row>
              )}
              {eligibility.maximumAge && (
                <Row>
                  <Col>
                    <span className={classNames(styles['section-body-text'], styles['bold'])}>Maximum Age: </span>
                    <span>{eligibility.maximumAge}</span>
                  </Col>
                </Row>
              )}
              {eligibility.healthyVolunteers && (
                <Row>
                  <Col>
                    <span className={classNames(styles['section-body-text'], styles['bold'])}>Healthy Volunteers: </span>
                    <span>{eligibility.healthyVolunteers}</span>
                  </Col>
                </Row>
              )}
              {(eligibility.inclusionParsed || eligibility.exclusionParsed) && (
                <>
                  <Row>
                    <AccordionSectionTabs classes={{ sectionAccordion: styles['section-accordion-tabs'] }}>
                      {(eligibility?.inclusionParsed?.some((x) => !x.isHeader) ||
                        eligibility?.exclusionParsed?.some((x) => !x.isHeader)) && <div>View:</div>}
                      {eligibility?.inclusionParsed?.some((x) => !x.isHeader) && (
                        <AccordionSectionTab
                          text="Inclusion Criteria"
                          classes={{ accordianTab: styles['accordian-tab'], accordianTabActive: styles['accordian-tab-active'] }}
                          isActive={selectedTab === 'inclusionParsed'}
                          onClick={() => setSelectedTab('inclusionParsed')}
                        />
                      )}
                      {eligibility?.exclusionParsed?.some((x) => !x.isHeader) && (
                        <AccordionSectionTab
                          text="Exclusion Criteria"
                          classes={{ accordianTab: styles['accordian-tab'], accordianTabActive: styles['accordian-tab-active'] }}
                          isActive={selectedTab === 'exclusionParsed'}
                          onClick={() => setSelectedTab('exclusionParsed')}
                        />
                      )}
                    </AccordionSectionTabs>
                  </Row>
                  <Row>{eligibility[selectedTab] && <EligibilityPane displayedData={eligibility[selectedTab]} />}</Row>
                </>
              )}
            </div>
          );
        })
      ) : (
        <Skeleton count={5} />
      )}
    </AccordionSection>
  );
};

export { ClinicalTrialEligibility as default, ClinicalTrialEligibility };
